import React, { Component } from 'react';
import { connect } from 'react-redux';

import HeaderContainer from './HeaderContainer';
import View from '../common/components/layouts/View';
import ErrorContainer from './ErrorContainer';
import DialogRoot from './DialogRoot';
import Toaster from './Toaster';
import { getUser, doRetrieveUser } from '../reducers/user';
import { getIsRetrievingUser } from '../reducers/app/isRetrievingUser';

class App extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		this.props.retrieveUser();
	}

	render() {
		const { isFetchingUser } = this.props;

		return (
			<View>
				<HeaderContainer />
				{/* Don't display main content when retrieving user */}
				{!isFetchingUser && this.props.children}
				<ErrorContainer />
				<DialogRoot />
				<Toaster />
			</View>
		);
	}
}

function mapStateToProps(state) {
	return {
		isFetchingUser: getIsRetrievingUser(state)
	};
}

function mapDispatchToProps(dispatch) {
	return {
		retrieveUser: () => dispatch(doRetrieveUser())
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/js/app/App.js